function isEmpty(str) {
    return (!str || str.length === 0);
}

module.exports = {
    isEmpty
};
